import { render, staticRenderFns } from "./ListDeliveryDetail.vue?vue&type=template&id=be2e005a&scoped=true&"
import script from "./ListDeliveryDetail.vue?vue&type=script&lang=js&"
export * from "./ListDeliveryDetail.vue?vue&type=script&lang=js&"
import style0 from "./ListDeliveryDetail.vue?vue&type=style&index=0&id=be2e005a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2e005a",
  null
  
)

export default component.exports